import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Markdown } from '../markdown/markdown.component';

import { BiddersNumberProps } from './boxTitle.types';

export const Container: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Regular};
`;

export const TagLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
  margin-bottom: 8px;
`;

export const NewsTitle: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
`;

export const Header: StyledComponent<'div'> = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
`;

export const ItemAttribute: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
  margin-top: 2px;
`;

export const PriceContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
  line-height: 18px;
  font-size: 14px;
  flex-wrap: wrap;
`;

export const DotSeparator: StyledComponent<'div'> = styled.div`
  width: 3px;
  height: 3px;
  background-color: ${Color.Black};
  border-radius: 50%;
  margin: 0 8px;
`;

export const BiddersNumber: StyledComponent<'div', BiddersNumberProps> = styled.div<BiddersNumberProps>`
  cursor: ${({ $withOnClick }: BiddersNumberProps): string => $withOnClick ? 'pointer' : 'default'};
  text-decoration: ${({ $withOnClick }: BiddersNumberProps): string => $withOnClick ? 'underline' : 'none'};
`;

export const SimpleMarkdownMessage: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Light};
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
  margin-top: 2px;
  display: block;

  strong {
    font-weight: ${FontWeight.Medium};
  }
`;

export const SimpleButton: StyledComponent<'button'> = styled.button`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
  margin-top: 2px;
  text-align: left;
`;
